import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { UserRole } from '../user/user.type';

import styles from './position-description.module.css';

type PositionDescriptionUiProps = {
  applyButton?: boolean;
  isAuthenticated?: boolean;
}

const ApplyButtonComponent = ({ isAuthenticated }: { isAuthenticated?: boolean }) => {
  return (
    <Link
      to={isAuthenticated ? '/dashboard' : '/signup'}
      state={{ userRole: UserRole.Founder }}
      className={classNames(
        styles.button,
        styles.applyButton,
      )}
    >
      Apply Now
    </Link>
  );
};

const PositionDescriptionUi = (props: PositionDescriptionUiProps) => {
  const {
    applyButton,
    isAuthenticated,
  } = props;

  return (
    <div className={styles.content}>
      <div className={styles.title}>
        Welcome to Foundermatcha — Your Journey Starts Here
      </div>
      {applyButton && (
        <div className={styles.buttonWrapper}>
          <ApplyButtonComponent isAuthenticated={isAuthenticated} />
        </div>
      )}

      <div className={styles.contentText}>
        Thank you for your interest in Foundermatcha.
        We’re building an exclusive online community where early-stage founders meet their ideal founding engineers. Whether you're looking for a CTO-level co-founder or a talented junior developer to help build your MVP, Foundermatcha connects you with mission-aligned tech talent.
        <br/>
        <br/>
        Our curated network includes 500+ developers — from FAANG alumni to university graduates, all driven by the desire to build meaningful tech from the ground up. They’re not just looking for jobs, they’re looking for startups to believe in.
      </div>
      <div className={styles.contentTitle}>
        <p>To join, we’ll need to confirm:
        </p>
      </div>
      <div className={styles.contentText}>
        <ul>
          <li>
            You’re a real person.
          </li>
          <li>
            You’re based in the UK or EU.
          </li>
          <li>
            You have a genuine startup idea you’re working on.
          </li>
          <li>
            You’re looking for a technical co-founder or developer.
          </li>
        </ul>
      </div>

      <div className={styles.contentTitle}>
        <p>How the Application Works</p>
      </div>
      <div className={styles.contentText}>
        Step 1: Click “Apply now” to access the Foundermatcha platform
        <br></br>
        <br></br>
        Step 2: Create a new account.
        <br></br>
        <br></br>
        Step 3: Share some high-level information about your startup — your vision, mission, values, and what makes your idea unique. You’ll also complete a short personality quiz to help us match you with aligned developers.
        <br></br>
        <br></br>
        Step 4: Submit your application for review.
        <br></br>
        <br></br>
        Step 5: If needed, we may reach out for a brief phone call or email to validate your details. Once accepted, you’ll receive access to our community and be introduced to compatible developers.
      </div>

      <div className={styles.contentTitle}>
        <p>Your Privacy is Our Priority
        </p>
      </div>
      <div className={styles.contentText}>
        We understand that some founders are building their startups while still employed. That’s why your profile is private by default and only shared with vetted, relevant matches. You control who sees your information — and when.
      </div>
      <div className={styles.contentText}>
        We also respect the confidentiality of your idea. You’ll only be asked to share high-level, non-sensitive details like your mission and what makes your startup exciting — never your “secret sauce.” Think of it as the trailer, not the full script.
      </div>

      {applyButton && (
        <div className={styles.buttonWrapper}>
          <ApplyButtonComponent isAuthenticated={isAuthenticated} />
        </div>
      )}
    </div>
  );
};

export default PositionDescriptionUi;
